import React, { useState, useEffect, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Offcanvas } from 'react-bootstrap';
import '../assets/css/style.css';
import headerImage from '../assets/css/img/logo.png';
import toggle from '../assets/css/img/toggle.png';
import call from "../assets/css/img/call.png";
import msg from "../assets/css/img/msg.png";
import SEO from '../component/SEO'
const Header = () => {
  const [show, setShow] = useState(false);
  const [hideUpperSection, setHideUpperSection] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeLink, setActiveLink] = useState('/'); // Default active link
  const sections = useRef({});
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [seoTitle, setSeoTitle] = useState("Axis Solar | Solarpower panels in hyderabad");
  const [seoDescription, setSeoDescription] = useState("Expert solar panel installations in Hyderabad, offering sustainable, affordable energy solutions for homes and businesses with optimized savings.");
  const sectionMap = {
    "#home": { title: "Axis Solar | Solarpower panels in hyderabad", description: "Axis Solar offers affordable, high-efficiency solar panel installations in Hyderabad, providing sustainable energy solutions for homes and businesses." },
    '#About': { title: "About | Tata Power Solar Partner for Reliable Solar Solutions in India ", description: "Axis Solar offers reliable, MNRE-compliant solar energy solutions for homes, businesses, and industry, reducing costs and supporting a greener India." },
    '#Solutions': { title: "Solutions |  10+ Years of Expertise in Solar Solutions, Sales, Support & Insurance", description: "Axis Solar offers high-quality solar solutions, exclusive sales, lifetime support, and insurance for reliable, sustainable energy." },
    '#Project': { title: "Projects | Residential & Commercial Solar Installations Across India", description: "Axis Solar delivers reliable, sustainable solar solutions for residential and commercial projects, reducing energy costs with 30+ years of expertise in quality installations."  },
    '#Subsidy': { title: "Subsidy | Free Electricity Scheme for Indian Households", description: "PM Surya Ghar Yojana offers 40% subsidy for solar panel installation to 1 crore households, promoting renewable energy and saving Rs. 75,000 crore annually."  },
    '#Contact': { title: "Contact | Expert Solar Installation & Support", description: "Contact Axis Solar for expert solar panel installation and support. Our team is ready to help with residential or commercial solar solutions for energy savings." },
  };
 
  const handleLogoClick = () => {
    window.location.href = '/';
  };
  const handleScroll = () => {
    if (window.scrollY > 50) {
      setHideUpperSection(true);
      setScrolled(true);
    } else {
      setHideUpperSection(false);
      setScrolled(false);
    }
  };
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Set up IntersectionObserver to track sections
  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 0.5 // Trigger when 50% of the section is visible
    };
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          setActiveLink(`#${entry.target.id}`);
        }
      });
    }, options);
    // Observe each section
    const sectionIds = ['home', 'About', 'Solutions', 'Project','Subsidy', 'Contact'];
    sectionIds.forEach(id => {
      const section = document.getElementById(id);
      if (section) {
        observer.observe(section);
      }
    });
    return () => {
      sectionIds.forEach(id => {
        const section = document.getElementById(id);
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, []);
  const handleNavLinkClick = (link) => {
    setActiveLink(link);
    setShow(false); // Close offcanvas on mobile after clicking
    const seoData = sectionMap[link];
    if (seoData) {
      setSeoTitle(seoData.title);
      setSeoDescription(seoData.description);
    
    }
  };
  return (
    <>
       <SEO title={seoTitle} description={seoDescription} />
      <div className={`header-container ${scrolled ? 'scrolled' : ''}`}>
        <div className="header-content d-flex justify-content-between align-items-end">
          <div className="logo-section">
            <a href="/" onClick={handleLogoClick}>
              <img src={headerImage} alt="Axis Solar" className="img-fluid" />
            </a>
          </div>
          <div className="nav-section d-flex align-items-end p-3">
            <nav className="d-none d-lg-flex">
              <ul className="nav">
                <li className="nav-item align-center">
                  <a
                    href="#home"
                    className={`nav-links ${activeLink === '#home' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#home')}
                  >
                    Home
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#About"
                    className={`nav-links ${activeLink === '#About' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#About')}
                  >
                    About Us
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Solutions"
                    className={`nav-links ${activeLink === '#Solutions' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Solutions')}
                  >
                    Solutions
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Project"
                    className={`nav-links ${activeLink === '#Project' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Project')}
                  >
                    Project
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Subsidy"
                    className={`nav-links ${activeLink === '#Subsidy' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Subsidy')}
                  >
                  Subsidy
                  </a>
                </li>
                <li className="nav-item">
                  <a
                    href="#Contact"
                    className={`nav-links ${activeLink === '#Contact' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Contact')}
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
            {/* Enquire Now button */}
            <button className="btn enquire-now-btn d-none d-lg-block">
              <a href="#Contact" style={{color:"#000"}} >Enquire Now</a>
            </button>
            {/* Toggle button for mobile and tablet view */}
            <button className="btn menu-btn d-lg-none" onClick={handleShow}>
              <span className="navbar-toggler-icon">
                <img src={toggle} alt="toggle" className="toggle text-center" />
              </span>
            </button>
          </div>
        </div>
      </div>
      {/* Offcanvas menu for mobile and tablet view */}
      <Offcanvas show={show} onHide={handleClose} placement="end" className="offcanvas-custom">
        <Offcanvas.Header closeButton style={{ borderBottom: "none" }} />
        <Offcanvas.Body>
          <h6><a
                    href="#home"
                    className={`nav-links ${activeLink === '#home' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#home')}
                  >
                    Home
                  </a>
          </h6><br />
          <h6>
          <a
                    href="#About"
                    className={`nav-links ${activeLink === '#About' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#About')}
                  >
                    About Us
                  </a>
          </h6><br />
          <h6>
          <a
                    href="#Solutions"
                    className={`nav-links ${activeLink === '#Solutions' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Solutions')}
                  >
                    Solutions
                  </a>
          </h6><br />
          <h6>
          <a
                    href="#Project"
                    className={`nav-links ${activeLink === '#Project' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Project')}
                  >
                    Project
                  </a>
          </h6><br />
          <h6>
        
                  <a
                    href="#Subsidy"
                    className={`nav-links ${activeLink === '#Subsidy' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Subsidy')}
                  >
                  Subsidy
                  </a>
                  </h6>
          <h6><br></br>
          <a
                    href="#Contact"
                    className={`nav-links ${activeLink === '#Contact' ? 'active' : ''}`}
                    onClick={() => handleNavLinkClick('#Contact')}
                  >
                    Contact
                  </a>
          </h6>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default Header;
